import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import Logo from '@/components/svg/Logo.vue'
import LogoAdaptify from '@/components/svg/Adaptify.vue'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      logo: {
        component: Logo
      },
      logoAdaptify: {
        component: LogoAdaptify
      }
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0F2A4D',
        secondary: '#FF6B35',
        accent: '#00B4D8',
        success: '#06D6A0',
        warning: '#FFD166',
        error: '#EF476F',
        black: '#11111f',
        white: '#FFFFFF',
        greydark: '#2B2D42',
        greylight: '#8D99AE',
        background: '#F8F9FA',
        'secondary-light': '#FF8A5B'
      }
    }
  }
});
